import { type TaxFiling } from '@fruitful/types';

export enum EmploymentStatus {
    FULL_TIME = 'FULL_TIME',
    PART_TIME = 'PART_TIME',
    FREELANCER = 'FREELANCER',
    BUSINESS_OWNER = 'BUSINESS_OWNER',
    SEARCHING = 'SEARCHING',
    STAY_AT_HOME_PARENT = 'STAY_AT_HOME_PARENT',
    UNEMPLOYED = 'UNEMPLOYED',
    RETIRED = 'RETIRED',
}

export enum IncomeType {
    FULL_TIME_SALARY = 'FULL_TIME_SALARY',
    PART_TIME_WAGE = 'PART_TIME_WAGE',
    FREELANCE = 'FREELANCE',
    CHILD_SUPPORT = 'CHILD_SUPPORT',
    ALIMONY = 'ALIMONY',
    OTHER = 'OTHER',
}

export enum IncomePayCycle {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    MONTHLY = 'MONTHLY',
    OTHER = 'OTHER',
}

export enum IncomeAdditionalCompensation {
    EQUITY = 'EQUITY',
    COMMISSION = 'COMMISSION',
    BONUS = 'BONUS',
    OTHER = 'OTHER',
}

export interface Income {
    id?: string;
    type: IncomeType;
    membershipId: string;
    belongsToUserId: string;
    description: string;
    annualSalaryCents?: number | null;
    payPerHourCents?: number | null;
    monthlyTakeHomeCents?: number | null;
    weeklyTakeHomeCents?: number | null;
    weeklyHours?: number | null;
    payCycle?: IncomePayCycle | null;
    additionalCompensation?: IncomeAdditionalCompensation[];
    additionalInformation?: string;
}

export interface IncomeInfo {
    primaryEmploymentStatus: EmploymentStatus;
    partnerEmploymentStatus?: EmploymentStatus;
    primaryTaxFiling: TaxFiling;
    partnerTaxFiling?: TaxFiling;
    income: Income[];
}

// Read DTO
export interface MembershipIncome extends Income {
    id: string; // id required on reads.
    createdAt: string;
    updatedAt: string;
}

// Update DTO
export interface MembershipIncomeUpsertDto extends Income {}
